import axios from "axios";
import Session from "./../session";

var instance = axios.create({
  baseURL: window.location.origin,
});

export default {
  namespaced: true,
  state: {
    verifying: false,
    admin: {
      id: "",
      name: "",
      email: "",
      password: "",
      role: "",
    },
    rateSetting: {
      rebate: 0,
      discount: 0,
      convenienceFee: 0,
      type: ""
    },
    bayadRateSetting: {
      rebate: 0,
      discount: 0,
      convenienceFee: 0,
      type: ""
    },
    submitting: false,
    bayadSubmitting: false,
  },
  getters: {
    admin(state) {
      return state.admin;
    },
    rateSetting(state) {
      return state.rateSetting;
    },
    bayadRateSetting(state) {
      return state.bayadRateSetting;
    },
  },
  mutations: {
    SET_Verifying(state, value) {
      state.verifying = value;
    },
    SET_Admin(state, value) {
      state.admin.id = value.id;
      state.admin.name = value.name;
      state.admin.email = value.email;
      if (value.role !== undefined) {
        state.admin.role = value.role;
      }
    },
    SET_Submitting(state, value) {
      state.submitting = value;
    },
    SET_BayadSubmitting(state, value) {
      state.bayadSubmitting = value;
    },
    SET_RateSetting(state, payload) {
      state.rateSetting = {
        rebate: payload.rebate || 0,
        discount: payload.discount || 0,
        type: payload.type || ""
      };
    },
    SET_BayadRateSetting(state, payload) {
      state.bayadRateSetting = {
        rebate: payload.rebate || 0,
        discount: payload.discount || 0,
        convenienceFee: payload.convenienceFee || 0,
        type: payload.type || ""
      };
    },
  },
  actions: {
    ValidateAdminCredential({ commit, getters }) {
      commit("SET_Verifying", true);
      var admin = getters.admin;
      var token = btoa(`${admin.email}:${admin.password}`);

      return new Promise((resolve, reject) => {
        instance
          .get("api/admin/token", {
            headers: {
              Authorization: "Basic " + token,
            },
          })
          .then(async function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            commit("SET_Verifying", false);
            reject(error.response);
          });
      });
    },
    GetAdminInfo({ commit }) {
      return new Promise((resolve, reject) => {
        instance
          .get("api/admin", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_Admin", response.data);
            resolve(true);
          })
          .catch(function (error) {
            reject(error.response);
          });
      });
    },
    AddRateSettings({ commit, getters }) {
      commit("SET_Submitting", true);

      return new Promise((resolve, reject) => {
        instance
          .post("api/admin/rateSettings", getters.rateSetting, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_Submitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Submitting", false);
            reject(error.response);
          });
      });
    },
    AddBayadRateSettings({ commit, getters }) {
      commit("SET_BayadSubmitting", true);

      return new Promise((resolve, reject) => {
        instance
          .post("api/admin/rateSettings", getters.bayadRateSetting, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_BayadSubmitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_BayadSubmitting", false);
            reject(error.response);
          });
      });
    },
    GetSmartRateSetting({ commit }) {
      return new Promise((resolve, reject) => {
        instance
          .get("api/admin/smart/rateSettings", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            commit("SET_RateSetting", response.data); 
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    GetBayadRateSetting({ commit }) {
      return new Promise((resolve, reject) => {
        instance
          .get("api/admin/bayad/rateSettings", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            commit("SET_BayadRateSetting", response.data); 
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
  },
};